export default __webpack_public_path__ + "static/media/Tombs.8a29014b.png";